export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 border-t border-background-700/30">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <a href="#hero" className="inline-flex items-center gap-2 no-underline mb-4" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }}>
              <span className="font-heading text-xl font-bold text-accent-500">777<span className="text-primary-500">影院</span></span>
            </a>
            <p className="text-xs text-foreground-500 leading-relaxed">
              777影院提供<strong className="text-foreground-400">高清免费影视资源</strong>，电影、电视剧、综艺全集<strong className="text-foreground-400">在线观看</strong>，<strong className="text-foreground-400">超清画质</strong>，<strong className="text-foreground-400">流畅不卡顿</strong>，<strong className="text-foreground-400">免费无广告</strong>，<strong className="text-foreground-400">极速播放</strong>。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '热门榜单', href: '#ranking' },
                { label: '精彩预告', href: '#media' },
                { label: '专题合集', href: '#index' },
                { label: '平台特色', href: '#features' },
                { label: '最新上线', href: '#updates' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' }); }}
                  className="text-xs text-foreground-500 hover:text-accent-400 transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">常见分类</h4>
            <div className="flex flex-col gap-2">
              {['古装剧场', '悬疑探案', '院线大片', '韩剧专场', '动漫世界'].map((cat) => (
                <a
                  key={cat}
                  href="#index"
                  onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
                  className="text-xs text-foreground-500 hover:text-accent-400 transition-colors"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-600 leading-relaxed">
              与众多优质内容平台保持合作关系，持续为影迷提供丰富多元的影视资源。合作信息将陆续公布，敬请期待。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#footer" onClick={(e) => e.preventDefault()} className="w-8 h-8 rounded-full bg-background-800/50 flex items-center justify-center hover:bg-accent-500/20 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-foreground-500 text-sm"></i>
              </a>
              <a href="#footer" onClick={(e) => e.preventDefault()} className="w-8 h-8 rounded-full bg-background-800/50 flex items-center justify-center hover:bg-accent-500/20 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-foreground-500 text-sm"></i>
              </a>
              <a href="#footer" onClick={(e) => e.preventDefault()} className="w-8 h-8 rounded-full bg-background-800/50 flex items-center justify-center hover:bg-accent-500/20 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-foreground-500 text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/30 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; 2026 777影院 - 高清免费影视在线观看平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#footer" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">服务条款</a>
            <a href="#footer" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">隐私政策</a>
            <a href="#footer" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}